import CarePage, {getServerSideProps} from "@page-containers/get-care/[slug]";

export {getServerSideProps};
export default CarePage;
